import { useLayoutEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useBreakpointHelpers } from '@sweetgreen/garnish';

/**
 * Clears the header show option if the viewport is extra small (XS).
 */
export const useToggleScreenHeader = () => {
  const navigation = useNavigation();
  const { isMobile } = useBreakpointHelpers();

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: !isMobile,
    });
  }, [navigation, isMobile]);
};
